import React from "react";
import { Facebook, Instagram, Linkedin } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { externalUrl } from "@/lib/url";

const brand = { facebook: "#1877F2", instagram: "#E4405F", linkedin: "#0A66C2" };

export default function SocialFloating() {
  const { settings } = useSite();
  const items = [
    { Icon: Facebook, raw: settings.facebook, name: "facebook" },
    { Icon: Instagram, raw: settings.instagram, name: "instagram" },
    { Icon: Linkedin, raw: settings.linkedin, name: "linkedin" },
  ]
    .map((it) => ({ ...it, url: externalUrl(it.raw) }))
    .filter((it) => !!it.url);

  if (!items.length) return null;

  return (
    <div className="fixed left-4 bottom-24 z-40 hidden flex-col gap-3 sm:flex md:left-6" data-testid="social-floating">
      {items.map(({ Icon, url, name }) => (
        <a
          key={name}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={name}
          data-testid={`social-float-${name}`}
          className="group grid h-11 w-11 place-items-center rounded-full bg-white shadow-soft transition-all duration-200 hover:scale-110"
          style={{ color: brand[name] }}
        >
          <Icon size={18} />
        </a>
      ))}
    </div>
  );
}
